<h2 class="action-text-title">{{title}}</h2>
<button mat-icon-button aria-label="cerrar actionable-button" (click)="onAction()" *ngIf="!actions">
  <mat-icon>{{icon}}</mat-icon>
</button>
<button mat-icon-button aria-label="cerrar actionable-button" (click)="onAction(action)" *ngFor="let action of actions" >
  <mat-icon>{{action.icon}}</mat-icon>
</button>
